<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form ref="formValidate" :model="formValidate" :label-width="110">
        <Row :gutter="16">
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品编号:" prop="commodityId" :label-width="120">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品名称:" prop="commodityName" :label-width="120">
              <Input v-model.trim="formValidate.commodityName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品类别:" prop="labelId" :label-width="120">
              <Select v-model="formValidate.labelId" clearable style="width: 100%;">
                <Option v-for="item in commodityCategory" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="供应商:" prop="supplierId" :label-width="120" >
              <Select v-model="formValidate.supplierId" clearable style="width: 100%;">
                <Option v-for="item in supplierList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="供应商商品编号:" prop="supplierCommodityNo" :label-width="120">
              <Input v-model.trim="formValidate.supplierCommodityNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品状态:" prop="useState" :label-width="120">
              <Select v-model="formValidate.useState" clearable style="width: 100%;">
                <Option v-for="item in commodityStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="primary"
            icon="md-add"
            style="margin-right: 8px"
            @click="createItem"
          >新增商品</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="useState">
          <Tag color="cyan" v-if="row.useState">已上架</Tag>
          <Tag color="red" v-else>已下架</Tag>
        </template>
        <template slot-scope="{row}" slot="marketing">
         <span>{{ row.marketingType == 0 ? '实时订购' :  '库存商品'}}</span>
        </template>
        <template slot-scope="{row, index}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-eye"
            @click="detailItem(row)"
          >详情</Button>
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-create"
            @click="updateItem(row, index)"
          >编辑</Button>
          <Button
            v-if="row.useState"
            type="text"
            class="text-link"
            size="small"
            icon="md-pause"
            @click="statusItem(row)"
          >下架</Button>
          <Button
            v-else
            type="text"
            class="text-link"
            size="small"
            icon="md-play"
            @click="statusItem(row)"
          >上架</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <CommodityCreateUpdate ref="commodityCreateUpdate" @success="createUpdateSuccess" />
    <CommodityDetail ref="commodityDetail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
// import utils from '../../utils'
import CommodityCreateUpdate from '../../components/commodity/CommodityCreateUpdate'
import CommodityDetail from '../../components/commodity/CommodityDetail'

export default {
  components: {
    CommodityCreateUpdate,
    CommodityDetail
  },
  data () {
    return {
      formValidate: {
        labelId: null,
        useState: null,
        commodityId: null,
        commodityName: null,
        supplierId: null,
        supplierCommodityNo: null,
        supplierCommodityName: null
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    ...mapGetters('commodity', ['commodityCategory', 'commodityStatus']),
    ...mapGetters('supplier', ['supplierList']),
    queryColumn () {
      return [
        {
          title: '商品编号',
          key: 'id',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '商品名称',
          key: 'commodityName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '商品类别',
          key: 'labelName',
          minWidth: 100,
          align: 'center'

        },
        {
          title: '供应商',
          key: 'supplierName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '供应商商品编号',
          key: 'supplierCommodityNo',
          minWidth: 150,
          align: 'center'
        },
        {
          // title: '商品单价（元）',
          title: '商品价格',
          key: 'facePrice',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '供应商价格',
          key: 'costPrice',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '商品数量',
          key: 'couponNum',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '商品状态',
          key: 'useState',
          minWidth: 100,
          slot: 'useState',
          align: 'center'
        },
        {
          title: '类型',
          key: 'marketingType',
          minWidth: 100,
          slot: 'marketing',
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 230,
          slot: 'action',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formSubmit () {
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.formSubmit()
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== null && element !== '') {
            params[item] = element
          }
        }
      }
      api.commodity.commodityList({
        ...params,
        sourceType: 0,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取商品列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 新增
    createItem () {
      this.$refs.commodityCreateUpdate.show('create')
    },
    // 编辑
    updateItem (row, index) {
      this.$refs.commodityCreateUpdate.show('update', row, index)
    },
    // 详情
    detailItem (row) {
      this.$refs.commodityDetail.show(row)
    },
    // 上下架
    statusItem (row) {
      const stateText = row.useState ? '下架' : '上架'
      this.$Modal.confirm({
        title: stateText + '确认',
        content: `<p>您确定要${stateText}此商品吗？</p>`,
        loading: true,
        onOk: () => {
          api.commodity.commodityUpDown({
            commodityId: row.id,
            useState: row.useState ? 0 : 1,
            sourceType: 0
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.$Message.success(`${stateText}成功!`)
            })
            .catch((err) => {
              this.$Modal.remove()
              setTimeout(() => {
                this.$Modal.error({
                  title: '抱歉',
                  content: `${stateText}失败: ` + err.message
                })
              }, 300)
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
    }
  },
  created () {
    if (!this.commodityCategory.length) {
      this.$store.dispatch('commodity/getCommodityCategory')
    }
    if (!this.supplierList.length) {
      this.$store.dispatch('supplier/getSupplierList')
    }
    this.getData()
  }
}
</script>
